import { useEffect, useState } from 'react';

// Read after mount, since the server render has no window.
export function useIsIFramed(): boolean {
  const [isIFramed, setIsIFramed] = useState(false);

  useEffect(() => {
    setIsIFramed(window.self !== window.top);
  }, []);

  return isIFramed;
}
